import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { ThemeProvider } from "@mui/material";
import { InputTextFieldTheme } from "./common/Themes";
import { InputBoxStyleGuide } from "./StyleGuideCSS";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { IconButton } from "@mui/material";
import { DDP_DATE_FORMAT } from "../../constants";
import moment from "moment";
import { DATE_FORMAT } from "../../constants";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";

export default function DatePickers(props) {
  const [value, setValue] = useState(props.value || null);
  const [error, setError] = useState(props.error || false);

  useEffect(() => {
    setError(props.error);
  }, [props.error]);

  const handleChange = (nextVal) => {
    setValue(nextVal);
    if (!props.disabled) {
      props.onChange(props.name, nextVal);
    }
  };

  const clearButton = {
    endAdornment: (
      <IconButton
        aria-label="toggle password visibility"
        onClick={() => setValue(null)}
      >
        <CancelOutlinedIcon
          fontSize="small"
          sx={{ color: "#575558", height: "20px", width: "20px" }}
        />
      </IconButton>
    ),
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      {/* we are using same theme as we used for InputTextField */}
      <ThemeProvider theme={InputTextFieldTheme}>
        <FormControl>
          <DesktopDatePicker
            label={props.label || "Date Picker"}
            inputFormat={props.inputFormat || DDP_DATE_FORMAT}
            value={value || null}
            renderInput={(params) => (
              <TextField
                required={props.required}
                {...params}
                sx={{ fontSize: "16px" }}
                error={props.error || !!error}
                size="normal"
              />
            )}
            onChange={handleChange}
          />
        </FormControl>
        <FormHelperText id="outlined-weight-helper-text" className="no-margin">
          <p
            style={{
              color: `${InputBoxStyleGuide.colorAlertNegative}`,
              fontSize: "12px",
            }}
          >
            {props.errorText ? props.errorText : ""}
          </p>
        </FormHelperText>
      </ThemeProvider>
    </LocalizationProvider>
  );
}
